import {tmsPackageEnabled} from '@netx/core-cart-next';
import {type ISavedCart} from '../schema';
import {savedCartIsNotEmpty} from './savedCartIsNotEmpty';

export const canCreateTMSObjectPackageFromSavedCart = (
	savedCart?: ISavedCart,
) => savedCartIsNotEmpty(savedCart) && tmsPackageEnabled();

export default canCreateTMSObjectPackageFromSavedCart;
